import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, Reveal } from "../components/Reveal";
import ShowroomCard from "../components/ShowroomCard";
import { NextPaths } from "../components/DivisionCards";
import { DIVISIONS, IMAGES } from "../data/site";
import useSeo from "../components/Seo";

const FUTURE = DIVISIONS.find((d) => d.slug === "upcoming-fleet");

export default function UpcomingFleet() {
  useSeo(
    "Upcoming Fleet — Coming Soon",
    "Vehicles and categories The Royal Mahaveer Roadlines Pvt Ltd plans to introduce — buses, public transport vehicles, staff transport, cars, tankers and additional trucks."
  );
  return (
    <>
      <PageHero
        overline="Upcoming Fleet"
        lines={[<>Coming</>, <><em className="italic text-gold-light">soon.</em></>]}
        desc="Our fleet is growing in phases. Every category below is planned — none of these vehicles are currently in our fleet, and none of the images represent our vehicles. Register your interest and we will contact you as operations begin."
      />

      <section className="py-24 sm:py-32" data-testid="upcoming-fleet-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid gap-6 sm:grid-cols-2 lg:gap-8" data-testid="upcoming-grid">
            {FUTURE.categories.map((c, i) => (
              <ShowroomCard key={c.title} item={c} index={i} testId={`upcoming-card-${i}`} />
            ))}
          </div>
          <Reveal>
            <p className="mt-10 max-w-3xl border border-dashed border-gold/25 px-6 py-5 text-xs leading-relaxed text-foreground/75" data-testid="upcoming-expandable-note">
              {FUTURE.expandableNote}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative overflow-hidden border-t border-gold/15 py-24" data-testid="upcoming-cta-section">
        <img
          src={IMAGES.network}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-20"
          style={{ filter: "grayscale(0.6) brightness(0.5) sepia(0.3)" }}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />
        <div className="relative z-10 mx-auto max-w-3xl px-6 text-center">
          <Reveal>
            <h2 className="font-heading text-3xl text-foreground sm:text-4xl">Have a future requirement?</h2>
            <p className="mx-auto mt-5 max-w-lg text-sm leading-relaxed text-muted-foreground">
              Tell us what you will need — upcoming categories are prioritized around registered demand.
            </p>
            <Link to="/quote" className="btn-solid group mt-9" data-testid="upcoming-quote-cta">
              Register Your Requirement
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>
      </section>

      <NextPaths exclude="/upcoming-fleet" />
    </>
  );
}
